import UI from '../core/ui'
import VDOM from '../vdom/vdom'

import {
  parseOptions,
  initLog,
  makeType
} from '../core/base'

import {
  listPanels,
  stopAutoPlay,
  resetAutoPlay
} from './slideshow-common'

import Dispatcher, {
  Stream
} from '../core/dispatcher-flyd'

import {
  modelChanged
} from './common'

import {
  first,
  getWith,
  guard,
  maybe,
  until
} from '../core/functions'

const swiped = (start_x, end_x, minSwipeAmount) => {
  const amount = Math.abs(end_x - start_x)
  return amount >= minSwipeAmount
}

const shuffle = (arr1, arr2, start = 0) => {
  arr1 = [...arr1]
  arr2 = [...arr2]
  for (let i = arr1.length - 1; i > 0; i--) {
    // const j = Math.floor(1 + Math.random() * i)
    const j = Math.floor(start + Math.random() * i)
    const temp = arr1[i]
    arr1[i] = arr1[j]
    arr1[j] = temp

    const temp2 = arr2[i]
    arr2[i] = arr2[j]
    arr2[j] = temp2
  }

  return [arr1, arr2]
}

const setSelected = model => {
  model = {
    ...model
  }

  if (model.selected < 0) {
    model.selected = model.panels - 1
    // model.selected = model.panels
  }

  if (model.selected > model.panels - 1) {
    model.selected = 0
  }

  return model
}

const setActiveControl = (dom, current) => {
  dom.findByRole('control').forEach((c, idx) => {
    if (idx === current) {
      c.addClass('active')
    } else {
      c.removeClass('active')
    }
  })
}

const deleteControls = dom => {
  dom.findByRole('control').forEach(c => {
    c.dispose()
  })
  dom.findByRole('controlset').forEach(c => c.dispose())
}

// const randomElement = items => items[Math.floor(Math.random() * items.length)]

{
  /* <nav data-role="control" data-mid="14839308779571" data-pid="4722470649907" class="slideshow-navigator-thumbnail">
    <div style="background-image: url('https://cdn.shopify.com/s/files/1/0072/4697/0931/products/GK_20IV_2037_20641.3491.K_20B_gallery_cover_180x.jpg?v=1605550599');" class="slideshow-thumbnail-image clearfix bg-center bg-cover"></div>
  </nav> */
}

const proto = {
  name: 'SlideShow',
  panels: null,
  controls: null,
  selected: 0,
  timer: null,
  hiddenControls: false,
  controlTimeout: null,

  initLog,
  parseOptions,
  listPanels,

  stopAutoPlay,
  resetAutoPlay,
  defaultOptions: {
    interval: 6000,
    controlInterval: 6000,
    hideControls: true,
    panelRole: 'slideshow-slide',
    minSwipeAmount: 60,
    setOpacity: false
  },

  init() {
    return {
      panels: this.listPanels().length,
      showControls: !this.options.hideControls,
      controlsShown: false,
      current: 0,
      selected: 0,
      autoplay: false,

      touch: {
        start: {},
        swiped: false
      }
    }
  },

  view(model) {
    model = {
      ...model
    }

    // this.log.warn(`view:`, {... model})

    if (model.selected === 0 && model.current === 0) {
      const selected = first(this.listPanels())
      selected.addClass('visible')
      selected.removeClass('hidden')
    }
    const showControls = model => {
      if (model.controlsShown) return model

      this.controlset.addClass('visible')
      this.controlset.removeClass('hidden')

      this.controlTimer = setTimeout(() => {
        this.eventStream.stream({
          type: 'hide-controls'
        })
      }, this.options.controlInterval)

      model.controlsShown = true

      return model
    }

    const hideControls = model => {
      model.controlsShown = false
      if (this.controlset != null) {
        this.controlset.addClass('hidden')
        this.controlset.removeClass('visible')
      }
      return model
    }

    const updateView = model => {
      this.stopAutoPlay()
      model = setSelected(model)
      this.hideSlide(model.current)
      this.showSlide(model.selected)
      this.resetAutoPlay()
      model.current = model.selected
      setActiveControl(this.dom, model.current)
      return model
    }

    if (this.controlset && model.showControls) {
      model = showControls(model)
    } else {
      model = hideControls(model)
    }

    return guard(model)
      .where(model.panels > 0)
      .where(model.current !== model.selected)
      .do(updateView, model)
  },

  updatePanelCount(model) {

    const update = {
      panels: this.listPanels().length,
      // current: 0,
      // selected: 0
    }
    return {
      ...model,
      ...update
    }
  },

  update(msg, model) {
    // console.log(`update`, msg)
    // if (msg.type !== "mousemove") {
    //   this.log.warn(`update:`, msg, {... model})
    // }

    switch (msg.type) {
      case 'hide-controls':
        model.showControls = false
        break
        // case 'remove-control':
        //   // this.log.warn(`removing control:`, msg.record)
        //   this.dom.findByRole('control')
        //     .filter(c => c.dataset.mid === msg.record.mid && c.dataset.pid === msg.record.pid)
        //     // .forEach(c => this.log.warn(`removing:`, c))
        //     .forEach(c => {
        //       this.log.warn(`removing:`, c)
        //       c.parentNode.removeChild(c)
        //     })
        //   break

      case 'show-next':
        model.selected = model.current + 1
        break
      case 'reset-length':
        // const update = {
        //   panels: this.listPanels().length,
        //   // current: 0,
        //   // selected: 0
        // }
        // model = {
        //   ...model,
        //   ...update
        // }

        model = this.updatePanelCount(model)
        break

      case 'click': {
        let c = msg.target
        if (!c.hasRole('control')) {
          c = c.closestByRole('control')
        }
        // this.log.warn(`click:`, c)
        const index = until(x => x != null, c.dataset)
          .try(dataset => {
            const key = dataset.mid == null ? dataset.pid == null ? `src` : `pid` : 'mid'

            // this.log.warn(`control click: key:`, key)
            // this.log.warn(`dataset:`, {
            //   ...dataset
            // })

            const idx = maybe(src => {
              const slides = this.listPanels()
              const slide = first(slides.filter(s => s.dataset[key] === src))
              return slides.indexOf(slide)
            })(getWith(key)(dataset))
            return idx
          })
          .try(dataset =>
            maybe(index => parseInt(index) - 1)(getWith('index')(dataset)))
          .last(x => {
            // console.log('slide not found:', x)
            // c.parentNode.removeChild(c)
          })

        model.selected = index

        break
      }
      case 'mousemove':
        model.showControls = true
        break

      case 'mouseleave':
        model.showControls = false
        break

      case 'keydown':
        guard()
          .where(!(msg.control || msg.shift))
          .where(this.dom.isInViewport())
          .do(() => {
            switch (msg.key) {
              case 'right':
              case 'ArrowRight':
                model.selected = model.current + 1
                break
              case 'left':
              case 'ArrowLeft':
                model.selected = model.current - 1
                break
            }
          })

        break

      case 'touchstart':
        model.touch.start = {
          x: msg.touches[0].pageX,
          y: msg.touches[0].pageY
        }

        break

      case 'touchmove':
        model.touch.swiped = true
        break

      case 'touchend':
        guard()
          .where(model.touch.swiped === true)
          .do(() => {
            maybe((start_x, end_x, minSwipeAmount) => {
              // const end_x = msg.changedTouches[0].pageX
              // const minSwipeAmount = this.options.minSwipeAmount

              if (swiped(start_x, end_x, minSwipeAmount)) {
                if (start_x < end_x) {
                  model.selected = model.current + 1
                } else {
                  model.selected = model.current - 1
                }
                model.touch.swiped = false
                model.touch.start = {}
              }
            })(
              getWith('touch', 'start', 'x')(model),
              msg.changedTouches[0].pageX,
              this.options.minSwipeAmount
            )
          })

        break
    }

    return model
  },

  initialize(slideshow) {
    guard(slideshow)
      .where(slideshow != null)
      .do(slideshow => {
        this.initLog()
        // this.log.enable();

        this.dom = slideshow

        this.parseOptions()
        this.controlset = first(this.dom.findByRole('controlset'))
        this.frame = maybe(controlset => first(controlset.findByRole(`frame`)))(this.controlset)

        // TODO: validate: remove controls without matching slides
        // TODO: randomize slides and controls in the same order
        // TODO: add limit to randomized slides: so for e.g. 100 slides, randomize, then show first X slides

        let currentModel = this.init()

        Dispatcher.map(msg => {
          switch (msg.type) {
            case 'popup-enabled':
            case 'popup-active':
              this.stopAutoPlay()
              break
            case 'popup-disabled':
            case 'popup-inactive':
              this.resetAutoPlay()
              break
          }
        })

        this.eventStream = new Stream()
        this.eventStream.map(msg => {
          let model = {
            ...currentModel
          }
          model = this.update(msg, model)
          if (modelChanged(currentModel, model)) {
            model = this.view(model)
          }
          currentModel = model
        })

        this.randomize()
        this.addControls()
        this.view(currentModel)

        this.unique(this.listPanels())

        if (this.dom.dataset.slideLimit != null) {
          // this.listPanels().forEach(p => this.addControl(p))
          // } else {
          this.prune()
          this.dom.findByRole('control').forEach(c => {
            c.dispose()
          })
          // this.listPanels().forEach(p => this.addControl(p))
        }
        this.buildControls()

        this.addEvents(currentModel)

        // first slide is sticky: make sure classes are set to visible or hidden
        this.listPanels().forEach((p, idx) => {
          this.hideSlide(idx)
          if (idx === 0) {
            this.showSlide(idx)
          }
        })

        // console.log([0..len])
        // .forEach(c => console.log(`counter: ${c}`))

        guard()
          .where(currentModel.panels > 1)
          .where(this.options.autoplay)
          .do(() => {
            this.autoPlay(this.options.interval)
          })

          this.eventStream.stream({
            type: 'reset-length'
          })
      })
  },

  buildControls() {
    if (this.dom.dataset.slideLimit != null || this.dom.dataset.buildControls != null) {
      this.listPanels().forEach(p => this.addControl(p))
    }
  },

  autoPlay(interval) {
    if (this.timer) {
      window.clearTimeout(this.timer)
    }
    if (!interval) {
      interval = this.options.interval
    }

    this.timer = setTimeout(() => {
      this.eventStream.stream({
        type: 'show-next'
      })
    }, interval)
  },

  randomize() {
    // this.log.warn(`randomize?`, this.options.randomize)
    guard()
      .where(this.options.randomize)
      .do(() => {
        const slides = this.listPanels()
        const controls = this.dom.findByRole('control')
        const first = slides[0]

        let r
        if (this.options.keepFirstSlide === true) {
          r = shuffle(slides, controls, 1)
        } else {
          r = shuffle(slides, controls)
        }
        // this.log.warn(`randomizing: shuffled`, [... r])

        r[0].forEach(s => s.getParent().appendChild(s))

        r[1]
          .filter(s => s != null)
          .forEach((s, idx) => {
            s.getParent().appendChild(s)
            s.dataset.index = idx + 1
          })

        if (this.options.keepFirstSlide !== true) {
          first.addClass('hidden')
          first.removeClass('visible')

          const newFirst = this.listPanels()[0]
          newFirst.addClass('visible')
          newFirst.removeClass('hidden')
        }
      })
  },

  // controlTemplate() {
  //   const template = first(this.controlset.findByRole("control_template").concat(this.controlset.findByRole("control")))

  //   if (template == null) {
  //     const vdom = new VDOM.Node()
  //     const d = vdom.appendElement(
  //       'div', {
  //         class: 'sscontrols hidden'
  //       }, {
  //         role: 'controlset'
  //       }
  //     )

  //     const ul = d.appendElement('ul')
  //     ul.appendElement(
  //       'li', {
  //         class: 'control'
  //       }, {
  //         role: 'control',
  //         // index: idx
  //       }
  //     )
  //   } else {
  //     return new VDOM.importDOM(template.content.children[0])
  //   }
  // },

  addControls() {
    // adds legacy controls (not thumbnails)

    // this.controlset = first(this.dom.findByRole("controlset"))

    guard()
      .where(this.options.addControls)
      .do(() => {
        deleteControls(this.dom)

        const vdom = new VDOM.Node()

        const d = vdom.appendElement(
          'div', {
            class: 'sscontrols hidden'
          }, {
            role: 'controlset'
          }
        )

        const ul = d.appendElement('ul')

        this.listPanels().forEach((p, idx) => {
          const cls = idx === 0 ? 'control active' : 'control'
          ul.appendElement(
            'li', {
              class: cls
            }, {
              role: 'control',
              index: idx
            }
          )
        })

        vdom.render()
        vdom.mount(this.dom)
      })
  },

  addControl(panel) {
    const dataset = panel.dataset
    // this.log.warn(`addding control called`, {... dataset})
    guard()
      .where(this.controlset != null)
      .where(dataset.preview != null)
      .do(() => {
        // this.log.warn(`addding controls`)
        const key = dataset.mid == null ? dataset.pid == null ? `src` : `pid` : 'mid'

        const id = dataset.pid ? dataset.pid : dataset.src
        const template = first(this.controlset.findByRole("control_template").concat(this.controlset.findByRole("control")))

        if (template != null) {
          const vdom = new VDOM.importDOM(template.content.children[0])
          const preview = first(vdom.findByRole("preview"))
          // this.log.warn(preview, typeof preview)
          if (preview != null) {
            preview.attrs["style"] = `background-image: url('${dataset.preview}')`
            // delete dataset.preview
          }

          if (id != null) {
            vdom.dataset[key] = id
          }
          if (dataset.mid != null) {
            vdom.dataset.mid = dataset.mid
          }
          vdom.render()
          vdom.mount(this.frame)
        }
      })
  },

  addEvents(model) {
    guard(this.dom.findByRole('control'))
      .where(controls => controls.length > 0)
      .do(controls => {
        if (model.panels > 1) {
          // or just hide?
          controls.forEach(c => {
            c.addEvent('click', this.eventStream.stream)
          })

          if (this.options.hideControls) {
            this.dom.addEvent('mousemove', this.eventStream.stream)
            this.dom.addEvent('mouseleave', this.eventStream.stream)
          }
        } else {
          deleteControls(this.dom)
        }
      })

    // navigate by touch
    this.dom.addEvent('touchstart', this.eventStream.stream)
    this.dom.addEvent('touchmove', this.eventStream.stream)
    this.dom.addEvent('touchend', this.eventStream.stream)

    // navigate by key
    window.addEvent('keydown', this.eventStream.stream)
  },

  showSlide(idx) {
    // this.log.warn(`showSlide: ${idx}`)
    const panels = this.listPanels()

    maybe(p => {
      p.addClass('visible')
      p.removeClass('hidden')
    })(panels[idx])
  },

  hideSlide(idx) {
    // this.log.warn(`hideSlide: ${idx}`)
    const panels = this.listPanels()

    maybe(p => {
      p.removeClass('visible')
      p.addClass('hidden')
    })(panels[idx])
  },

  // unique(array) {
  //   const keys = new Set(array
  //     .forEach(p => [p.dataset.pid, p.dataset.mid].join("")))

  //   const panel_index = {}

  //   array
  //     .forEach(p => {
  //       const key = [p.dataset.pid, p.dataset.mid].join("")
  //       panel_index[key] = p
  //     })

  //   keys.forEach(k => panel_index[k])
  // },

  unique(array) {
    const keys = []

    array
      .filter(p => p.dataset.pid != null && p.dataset.mid != null)
      .forEach(p => {
        const key = [p.dataset.pid, p.dataset.mid].join("")
        if (keys.contains(key)) {
          p.dispose()
        } else {
          keys.push(key)
        }
      })
  },

  prune() {
    const limit = parseInt(this.dom.dataset.slideLimit)
    // this.unique(this.listPanels())
    if (this.listPanels().length < limit) {
      // this.log.warn("keeping slides", this.listPanels().length, limit)
      return
    }
    // this.log.warn(`pruning slides: limit:`, parseInt(this.dom.dataset.slideLimit))
    // this.dom.findByRole('control').forEach(c => {
    //   c.dispose()
    // })

    // this.unique(this.listPanels())

    const panel_index = {}
    const [_, ...panels] = this.listPanels()
    panels
      .filter(p => p.dataset["keepSlide"] == null)
      .forEach(p => {
        const pid = p.dataset.pid
        if (panel_index[pid] == null) {
          panel_index[pid] = [p]
        } else {
          panel_index[pid].push(p)
        }
      })

    Object.keys(panel_index)
      .filter(k => panel_index[k].length > 1)
      .forEach(k => {
        const list = panel_index[k]
        const random = Math.floor(Math.random() * list.length)

        list.splice(random, 1)[0]
        list
          .forEach(p => {
            p.parentNode.removeChild(p)
          })

      })

    // this.listPanels().forEach(p => this.addControl(p))
    this.eventStream.stream({
      type: 'reset-length'
    })

    // this.log.warn(`slides: ${this.listPanels().length}`)
    // this.log.warn(`controls: ${this.dom.findByRole('control').length}`)
  }
}

export const SlideShow = makeType(proto)

UI.register('slideshow', SlideShow)